var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-message',{staticClass:"mb-24px",attrs:{"type":_vm.type,"has-icon":_vm.hasIcon,"icon-size":"is-medium"}},[_c('prismic-rich-text',{staticClass:"content",attrs:{"field":_vm.fragment.primary.message_content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }